import * as React from 'react';
import { InjectedIntlProps, injectIntl, FormattedMessage } from 'react-intl';
import { Row, Col } from 'react-flexbox-grid';

import Page from '../../../../components/page';
import Button from '../../../../patterns/atoms/button';
import VerticalDivider from '../../../../patterns/atoms/vertical-divider';
import Header from '../../../../patterns/molecules/header';
import Sidebar from '../../../../patterns/molecules/sidebar';
import DecoratedHeader from '../../../../patterns/atoms/decorated-header';
import { ReactComponent as FailureIcon } from '../../../../patterns/atoms/icons/failure.svg';
import Steps from '../../../../patterns/molecules/steps';

interface FormFailureProps extends InjectedIntlProps {
  steps: Array<string>;
  step: number;
}

class FormFailure extends React.PureComponent<FormFailureProps, {}> {
  public render(): JSX.Element {
    const { steps, step } = this.props;
    return (
      <Page
        header={
          <Header>
            <Steps steps={steps} active={step} failed={step - 1} />
          </Header>
        }
      >
        <Row>
          <Col xs={2} />
          <Col xs={6}>
            <DecoratedHeader level="h1">
              <FormattedMessage id="pages.form_failure.title" />
            </DecoratedHeader>
            <h3>
              <FormattedMessage id="pages.form_failure.subtitle" />
            </h3>
            <p>
              <FormattedMessage id="pages.form_failure.content" />
              <a href="mailto:support@solarisbank.com">support@solarisbank.com</a>
            </p>
            <Button variant="primary" external={true} href="/">
              <FormattedMessage id="pages.form_failure.try_again" />
            </Button>
          </Col>
          <Col xs={1}>
            <VerticalDivider />
          </Col>
          <Col xs={3}>
            <Sidebar icon={<FailureIcon />} center={true} />
          </Col>
        </Row>
      </Page>
    );
  }
}

export default injectIntl(FormFailure);
